var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59070_47321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.12 30.9L8.72 19.66L0 12.1L11.52 11.1L16 0.5L20.48 11.1L32 12.1L23.28 19.66L25.88 30.9L16 24.94L6.12 30.9Z",
    fill: "url(#paint0_linear_59070_47321)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59070_47321",
    x1: 4.26667,
    y1: 5.82,
    x2: 25.6323,
    y2: 28.5763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C421D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325272,
    stopColor: "#FBE67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535488,
    stopColor: "#FCFBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769917,
    stopColor: "#F7D14E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A041"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59070_47321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGradient);
export default __webpack_public_path__ + "static/media/star_gradient.d40cba1a0d4182343c600a63fa68f14e.svg";
export { ForwardRef as ReactComponent };